<template>
  <layout>
    <!-- 去掉多余信息 -->
      <div slot="nav"></div>
      <div slot="sub-nav"></div>
      <div slot="footer-service"></div>
    <!-- 去掉多余信息 -->

    <div class="game">

      <!-- banner -->
        <div class="banner">
          <div class="banner-box container">
            <div class="banner-logo"></div>
            <div class="banner-title">
              <h1 class="banner-main-title">在这里, 探索如何创建<br v-if="!isMobile">出色的<span>游戏</span></h1>
              <h2 class="banner-sub-title">通过 Google 最新的技术创新，将您的<br v-if="isMobile">愿景变为现实。</h2>
            </div>
            <com-button v-if="!isMobile" style="height: 44px;line-height: 44px;font-size: 16px;background:linear-gradient(90deg,rgba(45,132,243,1),rgba(25,116,232,1));" :width="'200'" :button-info="data['banner']">
              <i slot="icon" class="iconfont iconarrow_forward_"></i>
            </com-button>
            <com-button v-else style="height: 38px;line-height: 38px;font-size: 14px;margin:0;background:linear-gradient(90deg,rgba(45,132,243,1),rgba(25,116,232,1));" :width="'154'" :button-info="data['banner']">
              <i slot="icon" class="iconfont iconarrow_forward_"></i>
            </com-button>
          </div>
        </div>
      <!-- banner -->

      <!-- 游戏开发者峰会 -->
        <div id="summit" class="summit">
          <div class="container">
            <div class="summit-left">
              <h1 class="main-title">{{data['summit']['title']['mainTitle']}}</h1>
              <h2 v-if="!isMobile" class="sub-title">{{data['summit']['title']['subTitlePC']}}</h2>
              <h2 v-else class="sub-title">{{data['summit']['title']['subTitleMobile']}}</h2>

              <div v-if="!isMobile" class="content">
                <swiper :options="swiperOption1">
                  <swiper-slide v-for="(item, index) in summitList" :key="index + '' + item">
                    <a :href="item2.link" :target="item2.target || '_self'" class="summit-box" v-for="(item2, index2) in item" :key="index2 + '' + item2">
                      <img :src="item2.imgSrc" alt="" class="box-left">
                      <div class="box-right">
                        <h1 class="title">{{item2.title}}</h1>
                        <p class="text">{{item2.text}}</p>
                      </div>
                    </a>
                  </swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>

            </div>
            <div v-if="!isMobile" class="summit-right">
              <div class="summit-sign"></div>
              <swiper :options="swiperOption2">
                  <swiper-slide v-for="(item, index) in data['summit']['rightList']" :key="index + '&' + item">
                    <img :src="item" alt="" width="100%" height="100%">
                  </swiper-slide>
              </swiper>
            </div>
          </div>
          <div v-if="isMobile" class="content-mobile">
              <div class="wrapper" :style="{width: `${data['summit']['leftList'].length * (75 + 7)}vw`}">
                <a class="box" :href="itemM.link" v-for="(itemM, indexM) in data['summit']['leftList']" :key="indexM + '' + itemM">
                  <img :src="itemM.imgSrc" alt="" class="image">
                  <div class="info">
                    <h1 class="title">{{itemM.title}}</h1>
                    <p class="text">{{itemM.text}}</p>
                  </div>
                </a>
              </div>
            </div>
        </div>
      <!-- 游戏开发者峰会 -->

      <!-- 游戏开发挑战 -->
        <div id="challenge" class="challenge">
          <div class="container">
            <h1 class="title">{{data['challenge']['title']['mainTitle']}}</h1>
            <p class="text">{{data['challenge']['title']['subTitle']}}</p>
            <div class="box-list">
              <div class="box" v-for="(item3, index3) in data['challenge']['list']" :key="item3 + '&' + index3">
                <div class="box-title">
                  <img :src="item3.imgSrc" :style="item3.style" alt="" class="icon">
                  <h1 class="title">{{item3.title}}</h1>
                </div>
                <p class="box-text">{{item3.text}}</p>
              </div>
            </div>
          </div>
        </div>
      <!-- 游戏开发挑战 -->

      <!-- 解决方案 -->
        <div id="solution" class="solution">
          <div class="container">
            <h1 class="main-title">{{data['solution']['title']['mainTitle']}}</h1>
            <h2 class="sub-title">{{data['solution']['title']['subTitle']}}</h2>

            <div class="technical solution-item">
              <div class="line blue"></div>
              <div class="technical-content content">
                <game-card1 :cardInfo="item4" v-for="(item4, index4) in (showListKey.technicalShow ? technicalList  : (isMobile ? technicalList.slice(0, 2) : technicalList.slice(0, 3)))" :key="item4 + '&' + index4"></game-card1>
              </div>
              <div v-if="!showListKey.technicalShow && (isMobile ? (technicalList.length > 2) : (technicalList.length > 3))" class="button" @click="showList('technicalShow')">
                <span>查看全部 </span>
                <i slot="icon" class="iconfont iconarrow_forward_"></i>
              </div>
            </div>

            <div class="client solution-item">
              <div class="line green"></div>
              <div class="client-content content">
                <game-card2 :cardInfo="item5" v-for="(item5, index5) in (showListKey.clientShow ? clientList : (isMobile ? clientList.slice(0, 2) : clientList.slice(0, 3)))" :key="item5 + '&' + index5"></game-card2>
              </div>
              <div v-if="!showListKey.clientShow && (isMobile ? (clientList.length > 2) : (clientList.length > 3))" class="button" @click="showList('clientShow')">
                <span>查看全部 </span>
                <i slot="icon" class="iconfont iconarrow_forward_"></i>
              </div>
            </div>

            <div class="video solution-item">
              <div class="line yellow"></div>
              <div class="video-content content">
                <game-card3 :cardInfo="item6" v-for="(item6, index6) in (showListKey.videoShow ? videoList : (isMobile ? videoList.slice(0, 2) : videoList.slice(0, 3)))" :key="item6 + '&' + index6"></game-card3>
              </div>
              <div v-if="!showListKey.videoShow && (isMobile ? (videoList.length > 2) : (videoList.length > 3))" class="button" @click="showList('videoShow')">
                <span>查看全部 </span>
                <i slot="icon" class="iconfont iconarrow_forward_"></i>
              </div>
            </div>

          </div>
        </div>
      <!-- 解决方案 -->

      <!-- 交流分享 -->
        <div id="share" class="share">
          <div class="container">
            <!-- <div class="common-title">
              <h1 style="font-size: 40px">{{ data.activity[0]['textInfo']['top']['mainTitle'] }}</h1>
              <h2>{{ data.activity[0]['textInfo']['top']['subTitle'] }}</h2>
            </div> -->
            <swiper :options="swiperOption3">
              <swiper-slide v-for="(item, index) in data['share']" :key="index">
                <div style="display: flex">
                  <div class="act-content">
                    <div class="act-content-top">
                      <h1 style="font-size: 40px">{{ item['textInfo']['top']['mainTitle'] }}</h1>
                      <h2>{{ item['textInfo']['top']['subTitle'] }}</h2>
                    </div>
                    <div class="act-image" v-if="isMobile">
                      <img :src="item.imageList" alt="">
                    </div>
                    <div class="act-content-bottom">
                      <h1 class="title" v-html="item['textInfo']['bottom']['title']">{{ item['textInfo']['bottom']['title'] }}</h1>
                      <div class="timer-and-addr">
                        <i class="iconfont iconshijain"></i>
                        <span class="time">{{ item['textInfo']['bottom']['time'] }}</span>
                        <br v-if="isMobile"/>
                        <br v-if="isMobile"/>
                        <i class="iconfont icondidian"></i>
                        <span class="address">{{ item['textInfo']['bottom']['address'] }}</span>
                      </div>
                      <p class="text">{{ item['textInfo']['bottom']['text'] }}</p>
                    </div>
                    <div class="button-box">
                      <com-button :class="{'button-mobile-act': isMobile}" :selfClass="'blue'" :width="'160'" :button-info="item['button']"></com-button>
                    </div>
                  </div>
                  <div class="act-image" v-if="!isMobile">
                    <img :src="item.imageList" alt="">
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      <!-- 交流分享 -->

    </div>
  </layout>
</template>

<script>
import data from '@/data/game.js'

import Layout from 'components/layout/Layout'

import ComButton from '@/components/button1'
import GameCard1 from '@/components/gameCard1'
import GameCard2 from '@/components/gameCard2'
import GameCard3 from '@/components/gameCard3'

import { mapState } from 'vuex'

export default {
  components: {
    Layout,
    ComButton,
    GameCard1,
    GameCard2,
    GameCard3
  },
  data () {
    return {
      data: data,
      technicalList: data['solution']['technical'],
      clientList: data['solution']['client'],
      videoList: data['solution']['video'],
      showListKey: {
        technicalShow: false,
        clientShow: false,
        videoShow: false
      },
      swiperOption1: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        loop: true,
        grabCursor: true,
        speed: 1000,
        spaceBetween: 20,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        }
      },
      swiperOption2: {
        loop: true,
        speed: 1000,
        effect: 'fade',
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      },
      swiperOption3: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        loop: true,
        grabCursor: true,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        }
      }
    }
  },
  methods: {
    formatSummitList () {
      var newArr = []
      var arr = data['summit']['leftList']
      var num = Math.ceil(arr.length / 3)
      for (var i = 0; i < num; i++) {
        newArr.push(arr.slice(i * 3, 3 + i * 3))
      }
      return newArr
    },
    showList (prop) {
      this.showListKey[prop] = true
    }
  },
  computed: {
    ...mapState(['isMobile']),
    summitList () {
      return this.formatSummitList()
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
  @import '@/style/app.sass';

  .game {
    background-color: #fff;
    font-family: PingFang SC;
    @include mobile {
      overflow: hidden;
    }

    .banner {
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url('../../image/game/banner-pc.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      height: 540px;
      margin-bottom: 90px;
      @include mobile {
        height: 480px;
        margin-bottom: 40px;
        background-image: url('../../image/game/banner-mobile.png');
      }

      >.banner-box {
        display: flex;
        flex-direction: column;
        align-items: left;
        margin-top: -15px;
        @include mobile {
          padding-left: 15px;
        }

        >.banner-logo {
          width: 176px;
          height: 42px;
          margin-bottom: 34px;
          background-image: url('../../image/game/logo-white.png');
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          @include mobile {
            width: 120px;
            height: 19px;
          }
        }

        >.banner-title {

          >.banner-main-title {
            color: #fff;
            font-size: 60px;
            font-weight: 500;
            margin-bottom: 15px;
            line-height: 1.2;
            @include mobile {
              font-size: 36px;
              margin-bottom: 30px;
            }

            >span {
              color: rgba(25, 116, 232, 1);
            }
          }

          >.banner-sub-title {
            color: #fff;
            font-size: 22px;
            font-weight: 400;
            margin-bottom: 34px;
            @include mobile {
              font-size: 16px;
            }
          }
        }
      }
    }

    .summit {
      margin-bottom: 90px;
      @include mobile {
        margin-bottom: 40px;
      }

      .content-mobile {
        margin-left: 5vw;
        overflow-x: scroll;
        overflow-y: hidden;
        .wrapper {
          .box {
            display: block;
            width: 270px;
            height: 247px;
            float: left;
            font-size: 0;
            margin-right: 6vw;

            .image {
              width: 100%;
              height: 153px;
              margin-bottom: 14px;
              border-radius: 4px;
            }

            .info {
              height: 84px;
              padding-bottom: 6px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              box-sizing: border-box;
              .title {
                font-size: 17px;
                font-weight: 500;
                color: rgba(32,33,36,1);
                line-height: 1.2;
              }

              .text {
                font-size: 13px;
                font-weight: 400;
                color: rgba(95,99,104,1);
                line-height: 1.4;
                @include limit-line-numbers(2);
              }
            }
          }

        }
      }

      .container {
        display: flex;
        justify-content: space-between;
        height: 725px;
        @include mobile {
          height: auto;
          width: 90vw;
        }

        .summit-left {
          width: 50.7%;
          @include mobile {
            width: 100%;
          }

          .main-title {
            font-size: 40px;
            font-family: Google Sans;
            font-weight: 500;
            line-height: 1;
            margin-bottom: 20px;
            color: rgba(32,33,36,1);
            @include mobile {
              font-size: 24px;
              margin-bottom: 10px;
            }
          }

          .sub-title {
            font-size: 17px;
            line-height: 1.6;
            font-family: PingFang SC;
            font-weight: 400;
            text-align: justify;
            color: rgba(95,99,104,1);
            margin-bottom: 36px;
            @include mobile {
              font-size: 14px;
              line-height: 1.5;
              margin-bottom: 28px;
            }
          }

          .content {
            position: relative;

            .summit-box {
              display: flex;
              align-items: center;
              padding: 14px 25px 14px 14px;
              border: 1px solid rgba(218,220,225,1);
              border-radius: 5px;
              margin-bottom: 16px;
              &:last-of-type {
                margin-bottom: 0;
              }
              &:hover {
                background: linear-gradient(90deg, rgba(45, 132, 243, 1), rgba(25, 116, 232, 1));
              }
              &:hover .box-right .title,
              &:hover .box-right .text {
                color: #fff;
              }

              .box-left {
                width: 31.8%;
                height: 109px;
                margin-right: 28px;
                border-radius: 4px;
              }

              .box-right {
                width: auto;
                .title {
                  font-size: 20px;
                  font-weight: 500;
                  color: rgba(32,33,36,1);
                  line-height: 1.2;
                  margin-bottom: 14px;
                }

                .text {
                  // height: 40px;
                  font-size: 16px;
                  font-weight: 400;
                  line-height: 1.4;
                  color: rgba(95,99,104,1);
                  text-align: justify;
                  @include limit-line-numbers(2);
                }
              }
            }

            .swiper-pagination-bullets {
              position: static;
              width: 100%;
              text-align: left;
              margin-top: 44px;
              /deep/ span {
                position: relative;
                width: 15%;
                height: 2px;
                border-radius: 4px;
                background: rgba(32, 33, 36, 1);
                &::before {
                  content: '';
                  position: absolute; top: -15px; left: 0;
                  width: 100%;
                  height: 30px;
                  background: transparent;
                }
              }
              @include mobile {
                width: 100%;
                right: 0; left: auto; bottom: 0;
                text-align: center;
                span {
                  width: 20%;
                }
              }
            }
          }

        }

        .summit-right {
          position: relative;
          width: 540px;

          .summit-sign {
            position: absolute;
            right: 33px;
            top: 38px;
            z-index: 10;
            width: 316px;
            height: 35px;
            background: url('../../image/game/summit-sign.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
    }

    .challenge {
      height: 465px;
      padding: 90px 0;
      background: url('../../image/game/challenge-bg.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      box-sizing: border-box;
      @include mobile {
        padding: 40px 0;
        height: auto;
      }

      .container {
        display: flex;
        flex-direction: column;

        >.title {
          font-size: 40px;
          font-weight: 500;
          color: #fff;
          line-height: 1;
          margin-bottom: 20px;
          @include mobile {
            width: 90vw;
            font-size: 24px;
            margin-bottom: 14px;
          }
        }

        >.text {
          font-size: 24px;
          font-weight: 400;
          color: #fff;
          line-height: 1;
          margin-bottom: 37px;
          @include mobile {
            width: 90vw;
            font-size: 16px;
            line-height: 1.2;
            margin-bottom: 29px;
          }
        }

        .box-list {
          display: flex;
          justify-content: space-between;
          @include mobile {
            flex-direction: column;
            justify-content: none;
            align-items: center;
          }

          .box {
            width: 31.3%;
            height: 165px;
            padding: 34px 37px 45px 37px;
            background: #fff;
            border-radius: 5px;
            box-sizing: border-box;
            @include mobile {
              width: 90vw;
              height: 123px;
              padding: 25px 27px;
              margin-bottom: 13px;
              box-sizing: border-box;
              &:last-of-type {
                margin-bottom: 0;
              }
            }

            .box-title {
              @include mobile {
                // height: 36px;
              }
              .icon {
                display: inline-block;
                margin-right: 10px;
              }

              .title {
                display: inline-block;
                font-size: 20px;
                font-weight: 500;
                color: rgba(32,33,36,1);
                margin-bottom: 6px;
                @include mobile {
                  font-size: 18px;
                  margin-bottom: 0;
                }
              }
            }

            .box-text {
              font-size: 16px;
              font-weight: 400;
              line-height: 1.5;
              color: rgba(95,99,104,1);
              @include mobile {
                font-size: 14px;
              }
            }
          }
        }

      }
    }

    .solution {
      padding: 90px 0 60px 0;
      background: rgba(247, 247, 247, 1);
      @include mobile {
        padding: 40px 0 30px 0;
      }

      .container {

        .main-title {
          font-size: 40px;
          font-weight: 500;
          line-height: 1;
          margin-bottom: 20px;
          color: rgba(32, 33, 36, 1);
          @include mobile {
            font-size: 23px;
            margin-bottom: 14px;
            width: 90vw;
          }
        }

        .sub-title {
          font-size: 24px;
          line-height: 1;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(95, 99, 104, 1);
          margin-bottom: 40px;
          @include mobile {
            font-size: 16px;
            line-height: 1.4;
            margin-bottom: 24px;
            width: 90vw;
          }
        }

        .line {
          height: 1px;
          margin-bottom: 24px;
          &.blue {
            background: rgba(25, 116, 232, 1);
          }
          &.green {
            background: rgba(52, 168, 83, 1);
          }
          &.yellow {
            background: rgba(251, 188, 5, 1);
          }
          @include mobile {
            margin-bottom: 13px;
            width: 90vw;
            margin-left: auto;
            margin-right: auto;
          }
        }

        .solution-item {
          margin-bottom: 65px;
          @include mobile {
            margin-bottom: 30px;
            &:last-of-type {
              margin-bottom: 0;
            }
          }
          .content {
            display: flex;
            flex-wrap: wrap;
            // justify-content: space-between;
            margin-bottom: 5px;
            @include mobile {
              flex-direction: column;
              justify-content: none;
              align-items: center;
            }
          }

          >.button {
              color: rgba(25, 115, 232, 1);
              font-weight: 500;
              float: right;
              margin: 10px 20px 0 20px;
              cursor: pointer;
              @include mobile {
                font-size: 14px;
                float: none;
                margin: 10px auto;
                text-align: center;
              }
          }

        }

      }
    }

    .share {
      // height: 472px;
      padding: 90px 0 75px;
      @include mobile {
        padding-top: 40px;
        padding-bottom: 40px;
      }
      & .container {
        display: flex;
        position: relative;
        height: 100%;
        @include mobile {
          display: block;
          width: 90vw;
          // margin-left: auto;
          // margin-right: auto;
        }
        .swiper-container {
          padding-bottom: 30px;
        }
        .swiper-slide {
          @include mobile {
            width: 100% !important;
          }
        }
        /deep/ .swiper-pagination-bullets {
          width: 40%;
          left: 0;
          bottom: -9px;
          text-align: left;
          span {
            position: relative;
            width: 27%;
            height: 2px;
            border-radius: 4px;
            background: #333;
            &::before {
              content: '';
              position: absolute; top: -15px; left: 0;
              width: 100%;
              height: 30px;
              background: transparent;
              margin-right: 18px;
            }
          }
          @include mobile {
            width: 100%;
            left: 0; bottom: 4px;
            text-align: left;
            span {
              width: 20%;
            }
          }
        }
        // & .common-title {
        //   position: absolute;
        //   top: 0; right: 0;
        // }
        .act-image {
          margin-top: 24px;
          display: flex;
          align-items: center;
          @include mobile {
            display: block;
            // display: none;
            width: 100%;
            margin-top: 0px;
            margin-bottom: 22px;
          }
          & img {
            width: 100%;
          }
          .image-box {
            position: relative;
            height: 100%;
            .image-item {
              position: absolute;
              // border: 1px solid red;
            }
            .image-top {
              left: 0;
              top: 0;
              z-index: 10;
              width: 300px;
              height: 300px;
            }
            .image-center {
              right: 0;
              top: 50%;
              z-index: 9;
              transform: translateY(-50%);
              width: 300px;
              height: 300px;
            }
            .image-bottom {
              left: 50%;
              bottom: 0;
              z-index: 10;
              transform: translateX(-50%);
              width: 200px;
              height: 150px;
            }
          }
        }
        .act-content {
          flex: none;
          width: 574px;
          // flex: 1 1;
          padding-right: 46px;
          //border: 1px solid green;
          @include mobile {
            width: 100%;
            padding: 0;
          }

          .button-mobile-act {
            margin: 0;
            width: 154px;
            height: 36px;
            font-size: 14px;
            line-height: 36px;
            margin-bottom: 10px;
            margin-left: 4px;
            margin-right: 4px;
          }
          .act-content-top {
            margin-bottom: 50px;
            @include mobile {
              text-align: left;
              margin-bottom: 40px;
            }
            h1 {
              line-height: 1;
              color: $font-color1;
              font-size: 36px;
              font-weight: 500;
              margin-bottom: 20px;
              @include mobile {
                font-size: 24px !important;
                margin-bottom: 15px;
              }
            }
            h2 {
              letter-spacing: -1px;
              line-height: 1;
              color: $font-color2;
              font-size: $fontSize24;
              font-weight: 400;
              @include mobile {
                font-size: 16px !important;
                line-height: 1.3;
              }
            }
          }
          .act-content-bottom {
            margin-bottom: 28px;
            .title {
              line-height: 39px;
              color: $font-color1;
              font-size: 30px;
              font-weight: 500;
              margin-bottom: 20px;
              @include mobile {
                margin-bottom: 20px;
                line-height: 1.3;
                text-align: left;
                font-size: 18px;
                padding-left: 4px;
                padding-right: 4px;
              }
            }
            .timer-and-addr {
              line-height: 1;
              color: $font-color2;
              font-size: 16px;
              font-weight: 400;
              opacity: 0.9;
              margin-bottom: 20px;
              @include mobile {
                font-size: 14px;
                margin-bottom: 18px;
                padding-left: 4px;
                padding-right: 4px;
              }
              .time {
                margin-right: 23px;
              }
              .iconshijain, .icondidian {
                color: $primary1;
                font-size: 16px;
                margin-right: 8px;
              }
              @include mobile {
                .iconshijain {
                  font-size: 13px;
                }
                .icondidian {
                  font-size: 14px;
                }
              }
            }
            .text {
              // height: 90px;
              overflow: hidden;
              color: $font-color2;
              font-size: 16px;
              font-weight: 400;
              line-height: 26px;
              text-align: justify;
              @include mobile {
                font-size: 14px;
                line-height: 19px;
                padding-left: 4px;
                padding-right: 4px;
              }
            }
          }
        }
      }
    }

  }
</style>
